export const footerProps = () => ({
  shopName: {
    type: String,
    required: false,
    default: ""
  },
  isFidCarrefour: {
    type: Boolean,
    required: false,
    default: false
  },
  isNational: {
    type: Boolean,
    required: false,
    default: true
  },
  commandModes: {
    type: Array,
    required: true
  },
  hasServicePro: {
    type: Boolean,
    required: true
  },
  shop: {
    type: Object,
    required: false
  },
  shopId: {
    type: Number,
    required: false
  },
  webAlias: {
    type: String,
    required: false
  },
  showSeoContent: {
    type: Boolean,
    required: false,
    default: false
  },
  liens: {
    type: Object,
    required: false,
    default: null
  },
  rayons: {
    type: Object,
    required: false,
    default: null
  },
  isPro: {
    type: Boolean,
    required: false,
    default: false
  }
})

export const footerEmits = () => ([
  "openStoreLoc",
  "socialMediaLinkClicked"
])

export const useFooter = (emit) => {
  const linkClicked = (app) => {
    emit("socialMediaLinkClicked", app);
  }

  return { linkClicked }
}